<template>
  <div class="d-flex flex-column fill-height pa-4 pb-0">
    <v-row class="flex-grow-0">
      <v-col class="text-left">
        <v-menu v-model="sendParticipantEmailMenuShown"
                :close-on-content-click="false"
                offset-x
                min-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn :disabled="selectedParticipantIds.length === 0"
                   v-bind="attrs"
                   v-on="on">
              <v-icon class="mr-4">fas fa-paper-plane</v-icon>
              {{ $t('admin_enrollment.send_email') }}
            </v-btn>
          </template>

          <v-container>
            <v-card :elevation="2" class="pa-4">
              <v-select :label="$t('admin_enrollment.select_template')"
                        :items="emailTemplateOptions"
                        v-model="selectedParticipantEmailTemplate"></v-select>
              <v-radio-group v-model="participantEmailMode"
                             mandatory>
                <v-radio :label="$t('admin_enrollment.send_email')"
                         value="normal"></v-radio>
                <v-radio :label="$t('admin_participant.send_email')"
                         value="confirmation"></v-radio>
                <v-radio :label="$t('admin_participant.send_survey_email')"
                         value="survey"></v-radio>
              </v-radio-group>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text
                       @click="sendParticipantEmailMenuShown = false">
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn text
                       :disabled="!selectedParticipantEmailTemplate"
                       @click="participantEmailMode === 'survey' ? sendSurveyEmail(): sendParticipantEmail()">
                  {{ $t('admin_enrollment.send') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-menu>
      </v-col>
      <v-col class="text-right">
        <v-tooltip bottom>
          <template #activator="{on, attrs}">
            <v-btn class="ml-4"
                   @click="exportParticipants"
                   v-on="on"
                   v-bind="attrs">
              <v-icon>fas fa-file-export</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('export') }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <ParticipantList :event-id="eventId"
                     :refresh-trigger.sync="participantRefreshTrigger"
                     v-model="selectedParticipantIds"></ParticipantList>
  </div>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import ParticipantList from "@/components/event/participant/ParticipantList";
import {DateTime} from "luxon";

export default {
  name: 'EventParticipant',
  components: {ParticipantList},
  props: {
    eventId: String,

  },
  setup(props, {root, emit}) {
    onMounted(() => {
      // getEvent();
      getEmailTemplates();
    })

    // const event = ref(null);
    // const getEvent = function () {
    //   root.$callAPI('hkiarace/admin/event/', {id: props.eventId}, function (response) {
    //     event.value = {
    //       ...response.body.event,
    //       languages: JSON.parse(response.body.event.languages),
    //       from_time: response.body.event.from_time ? DateTime.fromFormat(response.body.event.from_time, 'HH:mm:ss').toFormat('HH:mm') : null,
    //       to_time: response.body.event.to_time ? DateTime.fromFormat(response.body.event.to_time, 'HH:mm:ss').toFormat('HH:mm') : null,
    //     };
    //   });
    // };

    // Email Templates
    const emailTemplates = ref([]);
    const emailTemplateOptions = computed(() => {
      return emailTemplates.value.map((t) => {
        return {value: t.id, text: t.name}
      });
    })
    const getEmailTemplates = function () {
      root.$callAPI('event/email_template/', {
        event_id: props.eventId,
      }, function (response) {
        emailTemplates.value = response.body.templates;
      });
    }

    const participantRefreshTrigger = ref(false);
    const searchParticipant = ref('');
    const selectedParticipantIds = ref([]);

    const sendParticipantEmailMenuShown = ref(false);
    const selectedParticipantEmailTemplate = ref(null);
    const participantEmailMode = ref('normal');
    const sendParticipantEmail = function () {
      if (confirm(root.$t('admin_notification_template.confirm_send_email'))) {
        root.$callAPI('hkiarace/admin/event/email_template/send_confirmation/', {
          participant_ids: selectedParticipantIds.value,
          template_id: selectedParticipantEmailTemplate.value,
        }, () => {
          participantRefreshTrigger.value = true;
        })
      }
    };
    const sendSurveyEmail = function () {
      if (confirm(root.$t('admin_notification_template.confirm_send_email'))) {
        root.$callAPI('hkiarace/admin/event/survey/send/', {
          event_id: props.eventId,
          participant_ids: selectedParticipantIds.value,
          template_id: selectedParticipantEmailTemplate.value,
        }, () => {
          participantRefreshTrigger.value = true;
        })
      }
    }

    const exportParticipants = function () {
      root.$downloadFile('hkiarace/admin/event/participant/export/', {
        event_id: props.eventId,
      }, 'participants.xlsx');
    }

    return {
      emailTemplateOptions,

      participantRefreshTrigger,
      searchParticipant,
      selectedParticipantIds,

      sendParticipantEmailMenuShown,
      selectedParticipantEmailTemplate,
      participantEmailMode,
      sendParticipantEmail,
      sendSurveyEmail,

      exportParticipants,
    }
  },
}
</script>
